import { VaultDNSAccessComponent } from './../vault-dnsaccess/vault-dnsaccess.component';
import { JMigratorToolsComponent } from './../jmigrator-tools/jmigrator-tools.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from '../home/home.component';
import { MenuComponent } from '../menu/menu.component';
import { ChangePasswordComponent } from './../change-password/change-password.component';
import { SuccessComponent } from '../success/success.component'
import { BaseScreenComponent } from '../base-screen/base-screen.component';
import { TrnxBaseScreenComponent } from '../trnx-base-screen/trnx-base-screen.component';
import { DynamicComponent } from '../dynamic/dynamic.component';
import { ScreenCreatorTransactionComponent } from '../screen-creator-transaction/screen-creator-transaction.component';
import { from } from 'rxjs';
import { ReportConfigurationComponent } from '../report-configuration/report-configuration.component';
import { MigrationJsonsComponent } from '../migration-jsons/migration-jsons.component';
import { QuicksightComponent } from '../quicksight/quicksight.component';
import { BaselineDataLoadComponent } from '../baseline-data-load/baseline-data-load.component';
import { SchedulerReportsComponent } from '../scheduler-reports/scheduler-reports.component';
import { ReportCreationComponent } from '../report-creation/report-creation.component';

import { ElasticsearchComponent } from '../elasticsearch/elasticsearch.component';
import { ReportnavlinksComponent } from '../reportnavlinks/reportnavlinks.component';
import { ReportlinksComponent } from '../reportlinks/reportlinks.component';
import { SchedulerComponent } from '../scheduler/scheduler.component';
import { FiltersComponent } from '../filters/filters.component';
import { ReportInstanceDetailsComponent } from '../report-instance-details/report-instance-details.component';
import { ReportInstanceHistoryComponent } from '../report-instance-history/report-instance-history.component';
import { ReportInstanceUpcomingComponent } from '../report-instance-upcoming/report-instance-upcoming.component';
import { CronJobIntervalComponent } from '../cron-job-interval/cron-job-interval.component';
import { VaulttovaultmigrationComponent } from '../vaulttovaultmigration/vaulttovaultmigration.component';

import { DashboardComponent } from '../dashboard/dashboard.component';
import { JaversauditComponent } from '../javersaudit/javersaudit.component';
import { VaultobjectattributesComponent } from '../vaultobjectattributes/vaultobjectattributes.component';
import { VaultobjectgroupComponent } from '../vaultobjectgroup/vaultobjectgroup.component';
import { MultipleobjectsextractionComponent } from '../multipleobjectsextraction/multipleobjectsextraction.component';
import { VaultDataMigrationEtlComponent } from '../vault-data-migration-etl/vault-data-migration-etl.component';
import { PlansCofigurationComponent } from '../plans-cofiguration/plans-cofiguration.component';
import { ETLComponent } from '../etl/etl.component';
import { EtoBMigrationComponent } from '../eto-bmigration/eto-bmigration.component';
import { PermissionsComponent } from '../permissions/permissions.component';
import {AssignUserRoleComponent} from '../assign-user-role/assign-user-role.component';
import {AuthGuard} from '../../shared/services/auth.guard';
import {TestExecutionControllerComponent} from "../test-execution-controller/test-execution-controller.component";
import {
  IncrementalDataLoadSchedulePopupComponent
} from '../baseline-data-load/incremental-data-load-schedule-popup/incremental-data-load-schedule-popup.component';
import {DataLoadComponent} from '../data-load/data-load.component';
import {IncrementalDataLoadComponent} from '../incremental-data-load/incremental-data-load.component';
import {ReportScreenComponent} from '../report-screen/report-screen.component';
import {ReportTemplateComponent} from '../report-template/report-template.component';
import { AuditTrailComponent } from '../audit-trail/audit-trail.component';
import { ReportFacetComponent } from '../report-facet/report-facet.component';
import { DatasetgroupComponent } from '../datasetgroup/datasetgroup.component';
import { WebScrapingComponent } from '../web-scraping/web-scraping.component';

import { AccessManagementComponent } from '../access-management/access-management.component';
import { VaultObjectRelationshipComponent } from '../vault-object-relationship/vault-object-relationship.component';

import { AvailableServiceComponent } from '../available-service/available-service.component';
import { AwssecretComponent } from '../awssecret/awssecret.component';
import { JsonToHtmlComponent } from '../json-to-html/json-to-html.component';
import { AudittrailHtmlReportComponent } from '../audittrail-html-report/audittrail-html-report.component';
import { ManageVisualsComponent } from '../manage-visuals/manage-visuals.component';
import {MigrationConfigComponent} from '../migration-config/migration-config.component';
import { PurgeDetailsComponent } from '../purge-details/purge-details.component';
import { MappingFileAutomationComponent } from '../mapping-file-automation/mapping-file-automation.component';
import { StageObjectComponent } from '../stage-object/stage-object.component';
import { AttributeMappingConfigComponent } from '../attribute-mapping-config/attribute-mapping-config.component';
import { FunctionalMappingComponent } from '../functional-mapping/functional-mapping.component';

import { CiomsAndMedwatchComponent } from '../cioms-and-medwatch/cioms-and-medwatch.component';

import { SummaryDashboardComponent } from '../summary-dashboard/summary-dashboard.component';
import { FieldMappingComponent } from '../field-mapping/field-mapping.component';
import { MappingtypeComponent } from '../mappingtype/mappingtype.component';
import { SnapshotComponent } from '../snapshot/snapshot.component';
import { MappingTestbedComponent } from '../mapping-testbed/mapping-testbed.component'

import { JsignalComponent } from '../jsignal/jsignal.component';
import { JsignalProductComponent } from '../jsignal-product/jsignal-product.component';

import { ForgotPasswordComponent } from 'src/app/session/forgot-password/forgot-password.component';
import { PasswordConfigurationComponent } from '../password-configuration/password-configuration.component';
import { SourceDataExtractionQueriesComponent } from '../source-data-extraction-queries/source-data-extraction-queries.component';
import { ExceptionQueryComponent } from '../exception-query/exception-query.component';
import { ProductLibraryComponent } from '../jsignal-product/library-support/product-library/product-library.component';
import { ProductDetailsComponent } from '../jsignal-product/library-support/product-library/product-details/product-details.component';
import { LibrarySupportComponent } from '../jsignal-product/library-support/library-support.component';
import { MeddraBrowserComponent } from '../jsignal-product/meddra-browser/meddra-browser.component';
import { StudyLibraryComponent } from '../jsignal-product/library-support/study-library/study-library.component';
import { StudyDetailsComponent } from '../jsignal-product/library-support/study-library/study-details/study-details.component';
import { ManagemdlscriptComponent } from '../managemdlscript/managemdlscript.component';
import { DeviationManagementComponent } from '../deviation/deviation-management/deviation-management.component';
import { ReviewApproveComponent } from '../jsignal-product/review-approve/review-approve.component';
import { CreateTemplateComponent } from '../jsignal-product/create-template/create-template.component';
import { ProductSafetyStrategyComponent } from '../jsignal-product/product-safety-strategy/product-safety-strategy.component';
import { ReviewActivitiesComponent } from '../jsignal-product/review-activities/review-activities.component';
import { LoadobjectmstrComponent } from '../loadobjectmstr/loadobjectmstr.component';
import { AlertsComponent } from '../jsignal-product/alerts/alerts.component';
import { MeetingsComponent } from '../jsignal-product/meetings/meetings.component';
import { MyTasksComponent } from '../jsignal-product/my-tasks/my-tasks.component';
// import { AlertProductMappingComponent } from '../jsignal-product/alert-product-mapping/alert-product-mapping.component';
// import { AlertSummaryComponent } from '../jsignal-product/alert-summary/alert-summary.component';
import { AlertMappingQuicksightComponent } from '../alert-mapping-quicksight/alert-mapping-quicksight.component';
import { AlertProductMappingComponent } from '../alert-product-mapping/alert-product-mapping.component';
import { HaRequestManagementComponent } from '../jsignal-product/ha-request-management/ha-request-management.component';
import { KeyChangesLogComponent } from '../jsignal-product/key-changes-log/key-changes-log.component';
import { FormulaBuilderComponent } from '../formula-builder/formula-builder.component';
import { ProductInfoComponent } from '../jsignal-product/product-info/product-info/product-info.component';
import { SignalsComponent } from '../signals/signals.component';
import { JsipAnalysisComponent } from '../jsip-analysis/jsip-analysis.component';
import { ActionsComponent } from '../jsignal-product/actions/actions.component';
import { LifeCycleComponent } from '../life-cycle/life-cycle.component';
import { AlertConfiguraionComponent } from '../jsignal-product/alerts/alert-configuraion/alert-configuraion.component';
import { ProductsInfoConfgComponent } from '../jsignal-product/products-info-confg/products-info-confg.component';
import { JeevObjectsComponent } from '../jeev-objects/jeev-objects.component';
import { WorkFlowComponent } from '../work-flow/work-flow.component';
import { ReviewActivityConfigComponent } from '../review-activity-config/review-activity-config.component';
import { SignalConfigComponent } from '../signals/signal-config/signal-config.component';

import { JsipDashboardComponent } from '../jsip-dashboard/jsip-dashboard.component';
import { AssignProductsComponent } from '../assign-products/assign-products.component';
import { ProductGroupProductMappingComponent } from '../product-group-product-mapping/product-group-product-mapping.component';
import { RoleProductGroupMappingComponent } from '../role-product-group-mapping/role-product-group-mapping.component';
import { ProductConfigurationComponent } from '../product-configuration/product-configuration.component';
import { CommonLibraryGridComponentComponent } from '../jsignal-product/library-support/common-library-grid-component/common-library-grid-component.component';
import { ImdrfBrowserComponent } from '../imdrf-browser/imdrf-browser.component';
import { ComputerizedSystemLibraryComponent } from '../computerized-system-library/computerized-system-library.component';
import { ReleaseLibraryComponent } from '../release-library/release-library.component';
import { RequirementsLibraryComponent } from '../requirements-library/requirements-library.component';
import { JaivikApplicationComponent } from '../jaivik-application/jaivik-application.component';
import { AuditTrailPageComponent } from '../audit-trail-page/audit-trail-page.component';









export const routes: Routes = [
  {
    path: "",
    redirectTo: "Menubar"
  },
  {
    path: 'success',
    component: SuccessComponent
  },
   {path: 'jaivik-app', component: JaivikApplicationComponent},
  {
    path: 'Menubar',
    component: MenuComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "", redirectTo: "home" },
      { path: 'home', component: HomeComponent },
      { path: 'baseComponent', component: BaseScreenComponent },
      { path: 'trnxBaseComponent', component: TrnxBaseScreenComponent },
      { path: 'screenCreatorTransaction', component: ScreenCreatorTransactionComponent },
      { path: 'reportConfiguration', component: ReportConfigurationComponent },
      { path: 'migrationjsons', component: MigrationJsonsComponent },
      { path: 'quickSight', component: QuicksightComponent  },
      { path: 'schedulerReports', component: SchedulerReportsComponent  },
      { path: 'elasticSearch', component: ElasticsearchComponent  },
      {path: 'vaultobjectgroup', component: VaultobjectgroupComponent},
      { path: 'Plans', component: PlansCofigurationComponent },
      { path: 'vaulttovaultmigration', component: VaulttovaultmigrationComponent  },
      {path:'jmigratorTool', component:JMigratorToolsComponent},
      {path:'scheduler', component:SchedulerComponent},
      {path:'filters', component:FiltersComponent},
      {path:'javers', component:JaversauditComponent},
      {path:'',component:AuditTrailComponent},
       {path:'auditTrail',component:AuditTrailPageComponent},
      {path:'vaultobjectattributes',component:VaultobjectattributesComponent},
      { path:'vaultdnsaccess',component:VaultDNSAccessComponent},
      {path: 'reportCreation',component: ReportCreationComponent},
      {path:'multipleobjectsextraction', component:MultipleobjectsextractionComponent},
      { path: 'etobmigration', component: EtoBMigrationComponent  },
      {path: 'reportInstanceDetails', component: ReportInstanceDetailsComponent,
        children: [
          { path: '',
            redirectTo: 'reportInstanceHistory'
          },
          {
            path: 'reportInstanceUpcoming',
            component: ReportInstanceUpcomingComponent
          },
          {
            path: 'reportInstanceHistory',
            component: ReportInstanceHistoryComponent
          }
        ]
       },
      {path:'croninterval',component:CronJobIntervalComponent},
      { path: 'dashboard', component: SummaryDashboardComponent},
      {path:'etlmigration', component:VaultDataMigrationEtlComponent},
      {path:'etlmigrationnew', component:ETLComponent},
      {path:'permissions',component:PermissionsComponent},
      {path:'assignuserrole',component:AssignUserRoleComponent},
      {path:'testexecutioncontroller',component:TestExecutionControllerComponent},
      {path:'webscraping',component:WebScrapingComponent}, 
      // {path: 'dataLoad', component: DataLoadComponent ,  children: [
      //     { path: '',
      //       redirectTo: 'baselineDataLoad'
      //     },
      // {path: 'incrementaldataload', component: IncrementalDataLoadComponent},
      // {path: 'baselineDataLoad', component: BaselineDataLoadComponent},
      // ]
      // },
  
      {path: 'incrementaldataload', component: IncrementalDataLoadComponent},
      {path: 'baselineDataLoad', component: BaselineDataLoadComponent},
      {path: 'reportscreen', component:ReportScreenComponent },
      {path:'templatereport',component:ReportTemplateComponent},
      {path:'facetManagement',component:ReportFacetComponent},
      {path:'datasetgroup',component:DatasetgroupComponent},
      {path:'accessmanagement',component:AccessManagementComponent},
      {path:'vaultObjectRelationship',component:VaultObjectRelationshipComponent},
      {path:'availservice',component:AvailableServiceComponent},
      {path:'awssecret',component:AwssecretComponent},
      {path:'casereport',component:JsonToHtmlComponent},
      {path:'audittrailreport',component:AudittrailHtmlReportComponent},
      {path:'managevisuals',component:ManageVisualsComponent},
      {path:'migrationconfigurationmstr',component:MigrationConfigComponent},
      {path:'purgedatamigration',component:PurgeDetailsComponent},
      {path:'mappingconfiguration',component:MappingFileAutomationComponent},
      {path:'stageobject',component:StageObjectComponent},
      {path:'attributemappingconfig',component:AttributeMappingConfigComponent},
      {path:'functionalmapping',component:FunctionalMappingComponent},
      {path:'fieldMapping',component:FieldMappingComponent},
      {path:'ciomsandmedwatch',component:CiomsAndMedwatchComponent},
      {path:'librarylist',component:MappingtypeComponent},
      {path:'snapshot',component:SnapshotComponent},
      {path:'MappingTestbed',component:MappingTestbedComponent},
      {path:'exceptionQueries',component:ExceptionQueryComponent},
      {path:'jsip-datamining',component:JsipAnalysisComponent},
      {path:'jsip-signalmanagement',component:JsipDashboardComponent},
      {path:'jsip-Summary',component:JsipDashboardComponent},
      {path:'jsip-analysis',component:JsipAnalysisComponent},
      {path:'jsignalProduct',component:JsignalProductComponent},
      {path:'passwordconfigurations',component:PasswordConfigurationComponent},
      {path:'jsip-meddrabrowser',component:MeddraBrowserComponent},
      {path:'jeevobjects',component:JeevObjectsComponent},
       {path:'sqlscripts__j',component:SourceDataExtractionQueriesComponent},
      // {path:'forgot-password',component:ForgotPasswordComponent}
      {path: 'jsip-librarysupport',component: LibrarySupportComponent,
          children: [
              {
                path: '',
                redirectTo: "productlibrary",  //default library
              },
              {
                path: 'productlibrary',
                children: [
                  {
                    path: '',
                    component: ProductLibraryComponent
                  },
                  {
                    path: 'details/:productId',
                    component: ProductDetailsComponent
                  }
                ]
              },
              {
                path: 'studylibrary',
                children:[
                  {
                    path:'',
                    component:StudyLibraryComponent
                  },
                  {
                    path:'studyDetails/:studyId',
                    component:StudyDetailsComponent
                  },
                ]
              },
              // future libraries can be added here
            {
              path: 'ime-library',
              component: CommonLibraryGridComponentComponent,
              data: { type: 'IME' }
            },
            {
              path: 'dme-library',
              component: CommonLibraryGridComponentComponent,
              data: { type: 'DME' }
            },
          {
              path: 'roa-library',
              component: CommonLibraryGridComponentComponent,
              data: { type: 'ROA' }
            },
            {
              path: 'codelist-library',
              component: CommonLibraryGridComponentComponent,
              data: { type: 'CODELIST' }
            }
            ]
          },
      {path:'managemdlscript',component:ManagemdlscriptComponent},
       {path:'jsip-deviationmanagement',component:DeviationManagementComponent},
       {path: 'jsip-deviationmanagement/:deviationId',component: DeviationManagementComponent},
      //  {path:'jsip-review&approve',component:ReviewApproveComponent},
      //  {path:'jsip-productstrategy',component:ProductSafetyStrategyComponent},
      //  {path:'jsip-productsafetystrategytemplate',component:CreateTemplateComponent},
       {path:'jsip-reviewactivities',component:ReviewActivitiesComponent},
      //  {path:'jsip-meddraBrowser',component:MeddraBrowserComponent},  
       {path:'loadobjectsmstr',component:LoadobjectmstrComponent},
      //  {path:'jsip-meddraBrowser',component:MeddraBrowserComponent},
      //  {path:'jsip-alertscreen',component:AlertsComponent},
       {path: 'jsip-meetings',component:MeetingsComponent},
       {path:'jsip-mytasks',component:MyTasksComponent},
       
      //  {path: 'jsip-alertproductmapping',component: AlertProductMappingComponent},   
        {path:'jsip-alertssummary',component:AlertMappingQuicksightComponent},
        {path: 'jsip-harequest',component: HaRequestManagementComponent},
        {path: 'jsip-keychanges',component: KeyChangesLogComponent},
        // {path:'jsip-productinfo' , component:ProductInfoComponent},
        {path:'jsip-signals',component:SignalsComponent}, 
        // {path:'jsip-reviewActivityConfig',component:ReviewActivityConfigComponent},     
           {path:'jsip-actions' , component:ActionsComponent},

           {path:'lifecycle',component:LifeCycleComponent},


          {path: '', component: AlertConfiguraionComponent ,
        children: [
          { path: '',
            redirectTo: 'jsip-alertscreen'
          },
          {
            path: 'jsip-alertscreen',
            component: AlertsComponent
          },
          {
            path: 'jsip-alertproductmapping',
            component: AlertProductMappingComponent
          }
        ]
       },
       
       {path: '', component: ProductsInfoConfgComponent ,
        children: [
          { path: '',
            redirectTo: 'jsip-productstrategy',pathMatch: 'full'
          },
          {
            path: 'jsip-productstrategy',
            component: ProductSafetyStrategyComponent
          },
          {
            path: 'jsip-review&approve',
            component: ReviewApproveComponent
          },
        ]
      },
       {path: 'workflow' , component: WorkFlowComponent},
       {path: 'jsip-signalConfiguration' , component: SignalConfigComponent},
       {path: 'jsip-formulabuilder' , component: FormulaBuilderComponent},
      //  {path: 'jsip-productAccess' , component: AssignProductsComponent},
      //  {path: 'jsip-productAccess' , component: ProductGroupProductMappingComponent},
        // {path: 'jsip-productAccess' , component: RoleProductGroupMappingComponent},
        // {path: 'jsip-productAccess' , component: ProductConfigurationComponent},
       {path: '', component: ProductConfigurationComponent ,
        children: [
          { path: '',
            redirectTo: 'jsip-productsafetystrategytemplate'
          },
          {
            path: 'jsip-productsafetystrategytemplate',
            component: CreateTemplateComponent
          },
          {
            path: 'jsip-reviewActivityConfig',
            component: ReviewActivityConfigComponent
          },
          {
            path: 'jsip-productAccess',
            component: RoleProductGroupMappingComponent
          },
           {
            path: 'jsip-productMapping',
            component: ProductGroupProductMappingComponent
          }
        ]
       },

       {path: 'jsip-imdrfBrowser' , component: ImdrfBrowserComponent},
       {path: 'computerizedSystems' , component: ComputerizedSystemLibraryComponent},
       {path: 'releaseLibrary' , component: ReleaseLibraryComponent},
       {path: 'requirementsLibrary' , component: RequirementsLibraryComponent},






    ]
  },

  {
    path: "Dynamic/:id",
    component: DynamicComponent
  }
];

 


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})

export class UserRoutingModule {

  print(componentName: string): string | void {
    // Loop through the main routes array
    for (const route of routes) {
      if (route.children) {
        // Loop through the child routes to check the component
        for (const childRoute of route.children) {
          if (componentName === childRoute.component?.name) {
            // If a match is found, log and return the path
            console.log('Found component path:', childRoute.path);
            return childRoute.path; // return path of the matched component
          }
        }
      }
    }
    console.log('Component not found');
  }
  
 }
